<template>
  <div>
    <LoadingOverlay :loading="loading" />
    <div class="agencyCentre-wrapper teamIncomeOverview-screen" style="background-color: #F2F2F2;">
      <div class="position-relative items-center agencyCentre-headerBar bg-white">
        <div class="angle black-angle" id="close" @click="goToAgencyCenter"></div>
        <div class="text-center agencyCentre-headerHD">Income Details</div>
      </div>
      <div class="mt-2 agencyTeam-wrapper">
        <div class="teamIncome-detailsBoxes" ref="scrollBox" @scroll="handleScroll">
          <div class="d-flex justify-content-between align-items-center teamIncome-detailsBox"
            v-for="(transData) in transactionData" :key="transData.id">
            <div class="income-leftBox">
              <div class="income-typeTitle">{{ transData.transaction_des }}</div>
            </div>
            <div class="d-flex justify-content-end align-items-center gap-1 incomeTransaction-box">
              <span class="d-flex justify-content-end align-items-center gap-1"><img :src='beansIcon' class="beansIcon"
                  alt="" />+</span>
              <span>{{ transData.credit }}</span>
            </div>
          </div>
          <!-- No more data message -->
          <!-- <div v-if="noMoreData" class="text-center text-muted py-3">
                            No more transactions to load.
                        </div> -->

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import './AgencyCentreStyle.css';
import beansIcon from '../../assets/images/beansIcon.png';
import LoadingOverlay from '../LoadingOverlay.vue';

// Same base URL logic as AgencyCentre
const API_BASE =
  (import.meta?.env?.VITE_API_BASE_URL) ||
  (typeof process !== 'undefined' && process.env?.VUE_APP_API_BASE_URL) ||
  'https://starmate.co.in/api';

const api = axios.create({ baseURL: API_BASE });

export default {
  name: 'TeamIncomeOverview',
  components: { LoadingOverlay },
  data() {
    return {
      transactionData: [],
      beansIcon,
      loading: false,
      hostId: null,
      startDate: '',
      endDate: '',
      currentPage: 1,
      nextPageUrl: null,
      noMoreData: false,
      authToken: ''
    };
  },
  async mounted() {
    // 1) token from /transaction-history/token=<JWT> or ?token=<JWT>
    const rawToken = this.$route.params.token || this.$route.query.token || '';
    this.authToken = this.normalizeToken(rawToken);

    if (!this.authToken) {
      console.error('Token missing. Expected ?token=<JWT> or /token=<JWT>');
      return;
    }

    // 2) set Authorization header on our axios instance
    api.defaults.headers.common['Authorization'] = `Bearer ${this.authToken}`;

    // (optional) debug request URLs
    api.interceptors.request.use((cfg) => {
      try {
        new URL((cfg.baseURL || '') + '/' + (cfg.url || ''));
        // console.log('[API] →', cfg.method?.toUpperCase(), full.toString(), 'params:', cfg.params);
      } catch (_) { 
        // ignore URL parse errors
      }
      return cfg;
    });

    // 3) read query params for host + date range
    const userId = this.$route.query.userid;
    const startDate = this.$route.query.start_date;
    const endDate = this.$route.query.end_date;

    if (userId && startDate && endDate) {
      this.hostId = userId;
      this.startDate = startDate;
      this.endDate = endDate;
      await this.fetchTransactionData();
    } else {
      console.warn('Missing required query parameters: userid, start_date, end_date');
    }
  },
  methods: {
    // Accepts "token=<jwt>" or "<jwt>"
    normalizeToken(input) {
      if (!input || typeof input !== 'string') return '';
      return input.startsWith('token=') ? input.slice(6) : input;
    },

    async fetchTransactionData() {
      if (this.loading || this.noMoreData) return;
      this.loading = true;
      try {
        const { data } = await api.get('hostearninghistoryfromagency', {
          params: {
            hostid: this.hostId,
            start_date: this.startDate,
            end_date: this.endDate,
            page: this.currentPage
          }
        });

        const payload = data?.result || {};
        const items = payload.data || [];
        const next = payload.next_page_url || null;

        if (Array.isArray(items) && items.length > 0) {
          this.transactionData.push(...items);
          this.currentPage += 1;
          this.nextPageUrl = next;
        }

        if (!next || items.length === 0) {
          this.noMoreData = true;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.loading = false;
      }
    },

    handleScroll() {
      const box = this.$refs.scrollBox;
      if (!box) return;
      if (box.scrollTop + box.clientHeight >= box.scrollHeight - 10) {
        if (!this.noMoreData) {
          this.fetchTransactionData();
        }
      }
    },

    goToAgencyCenter() {
      // If you prefer preserving the token explicitly instead of history back:
      // const token = this.normalizeToken(this.$route.query.token || this.$route.params.token || '');
      // this.$router.push({ path: '/agency-centre', query: { token } });
      this.$router.go(-1);
    }
  }
};
</script>
